import {newStepValue} from "../../../../../services/flowBuilder/utils/constants";
import {EditPermissions} from "../../../../../../../shared/models";
import {UntypedFormArray, UntypedFormControl, UntypedFormGroup} from "@angular/forms";
import {getEditTypes} from "../../../delegatorUtils";
import {required} from "../../../../../../../shared/utils";
import {ActionParamsForm} from "../send-template/sendTemplate";

export interface HttpCallForm {
    name: string;
    description: string;
    apiName: string;
    headers: { [index: string]: string };
    queryStrings: { [index: string]: string };
    body: string | { [index: string]: any };
    result: { [index: string]: string };
}

export interface KeyValue {
    key: string;
    value: string;
}

const defaultResults: { [index: string]: string } = {
    other: newStepValue,
    error: newStepValue,
    timeout: newStepValue,
    'max-connections': newStepValue,
}

export class HttpCallNode {

    public static toForm(stepData: { [index: string]: any }, editPermissions: EditPermissions): UntypedFormGroup {

        const {editMenuTextOnly, editFlows} = getEditTypes(editPermissions);

        let httpCallForm: HttpCallForm = this.buildHttpForm(stepData);

        const httpForm = new UntypedFormGroup({
            name: new UntypedFormControl({
                value: httpCallForm.name,
                disabled: !editFlows
            }, [required('Name')]),
            description: new UntypedFormControl({
                value: httpCallForm.description,
                disabled: !editFlows
            }, [required('Description')]),
            apiName: new UntypedFormControl({
                value: httpCallForm.apiName,
                disabled: !editFlows
            }, [required('Api Name')]),
            headers: this.buildKeyValue(httpCallForm.headers, editFlows),
            queryStrings: this.buildKeyValue(httpCallForm.queryStrings, editFlows),
            result: this.buildResults(httpCallForm.result, editFlows),
        });

        if (httpCallForm.body !== undefined) {
            httpForm.addControl("body", this.buildHttpBody(httpCallForm.body, editFlows))
        }

        return httpForm;
    }

    private static buildHttpForm(stepData: { [index: string]: any }): HttpCallForm {

        const action = stepData?.action ? stepData?.action : {};
        const actionParams = action?.actionParams ? action?.actionParams : {};

        return {
            name: action?.name ? action?.name : "",
            description: action?.description ? action?.description : "",
            apiName: actionParams?.apiName ? actionParams?.apiName : "",
            headers: actionParams?.headers ? actionParams?.headers : {},
            queryStrings: actionParams?.queryStrings ? actionParams?.queryStrings : {},
            result: action?.result ? action?.result : defaultResults,
            body: actionParams?.body ? actionParams?.body : undefined
        };
    }

    public static buildKeyValue(actionParams: { [index: string]: any }, editFlows: boolean): UntypedFormArray {

        const actionParamsControl: UntypedFormArray = new UntypedFormArray([]);
        for (let key in actionParams) {
            const value = actionParams[key];
            const control = this.addKeyValue(editFlows, {key, value})
            actionParamsControl.push(control);
        }

        return actionParamsControl;
    }

    private static buildResults(actionParams: { [index: string]: any }, editFlows: boolean): UntypedFormArray {

        const actionParamsControl: UntypedFormArray = new UntypedFormArray([]);

        for (let key in actionParams) {
            const value = actionParams[key];
            let control = this.addKeyValue(editFlows, {key, value})

            if (key in defaultResults) {
                control = new UntypedFormGroup({
                    key: new UntypedFormControl({
                        value: key ? key : "",
                        disabled: true
                    }),
                    value: new UntypedFormControl({
                        value: value ? value : "",
                        disabled: !editFlows
                    }),
                })
            }

            actionParamsControl.push(control);
        }

        return actionParamsControl;
    }


    public static buildHttpBody(body: any, editFlows: boolean): UntypedFormArray | UntypedFormControl {
        if (body === undefined) {
            return undefined;
        }
        if (typeof body === "object") {
            return this.buildResults(body, editFlows)
        }
        return new UntypedFormControl({
            value: body,
            disabled: !editFlows
        }, []);
    }

    public static addKeyValue(editFlows: boolean, keyValue?: KeyValue): UntypedFormGroup {
        return new UntypedFormGroup({
            key: new UntypedFormControl({
                value: keyValue?.key ? keyValue.key : "",
                disabled: !editFlows
            }),
            value: new UntypedFormControl({
                value: keyValue?.value ? keyValue.value : "",
                disabled: !editFlows
            }),
        })
    }

    private action: any = {};

    constructor() {
        this.action = {
            actionType: "httpCall"
        };
    }

    get nodeData(): {} {
        return {
            action: this.action,
            'type': 'action',
            metadata: {
                nodeVersion: '1.0.0'
            }
        };
    }

    addActionParams(params: HttpCallForm) {
        const {name, description, apiName, result, headers, queryStrings, body} = params;

        this.action = {
            ...this.action,
            description,
            name,
            actionParams: {
                headers: this.arrayToObject(headers),
                apiName,
                queryStrings: this.arrayToObject(queryStrings),
            },
            result: this.arrayToObject(result),
        }

        if (body !== undefined ) {
            this.action.actionParams['body'] = this.castBody(body);
        }

    }

    private arrayToObject(data: any): { [index: string]: string } {
        const newObj = {};
        for (let keyValue of data) {
            newObj[keyValue.key] = keyValue.value
        }
        return newObj;
    }

    private castBody(body: any): { [index: string]: string } | string {
        if (typeof body === "string") {
            return body;
        }
        return this.arrayToObject(body);
    }
}


// json: {
//     action: {
//         name: '',
//         description: '',
//         actionType: 'httpCall',
//         actionParams: {
//           headers: {},
//           queryStrings: {},
//           apiName: '',
//           body: "" OR body: {}
//         },
//         result: {
//             other: newStepValue,
//             error: newStepValue,
//             timeout: newStepValue,
//             'max-connections': newStepValue,
//         },
//     },
//     type: 'action',
// }
